/*
	import { listEvents } from '@/services/CalendarEvent/CommunityCalendarEvent/List';

  const { list, successful, message } = await listEvents ({
    params: {
			hoaID
    }
  });
  if (!successful) {
    console.error (message);
    return;
  }
*/

import kms from '@/services/kms'
import _get from 'lodash/get'

export async function listEvents({ params }) {
  let message = 'The community calendar events list could not be retrieved.'

  try {
    const result = await kms.get(`/CalendarEvent/CommunityCalendarEvent/List`, {
      params
    })

    let list = _get(result, 'results', [])
    if (!Array.isArray(list)) {
      list = []
    }

    return {
      successful: true,
      message,
      list
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    list: []
  }
}
